import { OrganizationRole } from '@/graphql';

import { useUserLoading } from './useUser';

/**
 * Returns whether the current user has creator permissions, meaning they can modify applications, models, data, etc.
 */
function useIsCreator(): boolean {
  const { user } = useUserLoading();
  return !!user?.roleName && user?.roleName !== OrganizationRole.Operator;
}

/**
 * Returns whether the current user has creator permissions,
 * meaning they can modify applications, models, data, etc, but they are not admins.
 */
function useIsNonAdminCreator(): boolean {
  const { user } = useUserLoading();
  return !!user.roleName && user.roleName === OrganizationRole.Creator;
}

export { useIsCreator, useIsNonAdminCreator };
